<template>
  <BaseNavbar
    navbarClass="is-primary"
    :startItems="startItems"
    :endItems="endItems"
    @action="handleAction"
  >
    <template #end-items>
      <b-navbar-item>
        <ClassSelectorButton />
      </b-navbar-item>
    </template>
  </BaseNavbar>
</template>

<script>
import ClassSelectorButton from "@/components/teacher/ClassSelectorButton.vue";
import { auth } from "@/services/firebase";
import sacService from "@/services/sac";
import BaseNavbar from "./BaseNavbar.vue";

export default {
  name: "TeacherNavbar",
  components: { BaseNavbar, ClassSelectorButton },

  computed: {
    startItems() {
      return [
        {
          label: "Home",
          icon: "fas fa-home",
          to: { path: "/teacher/home" },
        },
        {
          label: "Topics Explorer",
          icon: "fas fa-sitemap",
          to: { path: "/teacher/topics" },
        },
        {
          label: "Examples",
          icon: "fas fa-chess-board",
          to: { path: "/teacher/examples" },
        },
        {
          label: "Curriculum",
          icon: "fas fa-book",
          to: { path: "/teacher/curriculum" },
        },
        {
          label: "Lectures",
          dropdown: true,
          items: [
            {
              label: "Planning",
              icon: "fas fa-chalkboard",
              to: { path: "/teacher/lectures" },
            },
            {
              label: "Calendar",
              icon: "fas fa-calendar",
              to: { path: "/teacher/lectures/calendar" },
            },
            {
              label: "Homework",
              icon: "fas fa-clipboard-list",
              to: { path: "/teacher/homework" },
            },
            {
              label: "Student progress",
              icon: "fas fa-chart-line",
              to: { path: "/teacher/progress" },
            },
          ],
        },
        {
          label: "📖 Lessons",
          dropdown: true,
          items: [
            {
              label: "Lessons",
              icon: "fas fa-book-open",
              to: { path: "/teacher/lessons" },
            },
            {
              label: "Live Lessons",
              icon: "fas fa-broadcast-tower",
              to: { path: "/teacher/liveLessons" },
            },
          ],
        },

        {
          label: "Tournaments",
          dropdown: false,
          icon: "fas fa-chess-queen",
          to: { path: "/teacher/class-tournaments" },
        },
      ];
    },

    endItems() {
      const teacherInfo = sacService.teacherInfo();

      return [
        {
          label: `${teacherInfo.firstName} ${teacherInfo.lastName}`,
          dropdown: true,
          items: [
            {
              label: "Logout",
              icon: "fas fa-sign-out-alt",
              action: "logout",
            },
          ],
        },
      ];
    },
  },

  methods: {
    handleAction(action) {
      if (action === "logout") {
        this.logout();
      }
    },

    async logout() {
      await auth.signOut();
      sacService.logout();
      this.$router.replace({ name: "login" });
    },
  },
};
</script>
